import React from "react";
import CryptoTransactionsView from "./View";

const CryptoTransactions = () => {
  return <CryptoTransactionsView />;
};

export default CryptoTransactions;
